import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue";
const _hoisted_1 = {
  style: {
    "height": "100%"
  }
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "page-header"
};
const _hoisted_7 = {
  style: {
    "margin-right": "10px"
  }
};
const _hoisted_8 = {
  class: "msg-icon"
};
const _hoisted_9 = {
  class: "msg-icon"
};
const _hoisted_10 = {
  class: "pre-step"
};
const _hoisted_11 = {
  class: "menu-item-title"
};
const _hoisted_12 = {
  class: "menu-item-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HomeOutlined = _resolveComponent("HomeOutlined");
  const _component_a_menu_item = _resolveComponent("a-menu-item");
  const _component_ProjectOutlined = _resolveComponent("ProjectOutlined");
  const _component_a_sub_menu = _resolveComponent("a-sub-menu");
  const _component_ToolOutlined = _resolveComponent("ToolOutlined");
  const _component_UsergroupAddOutlined = _resolveComponent("UsergroupAddOutlined");
  const _component_GlobalOutlined = _resolveComponent("GlobalOutlined");
  const _component_SoundOutlined = _resolveComponent("SoundOutlined");
  const _component_InteractionOutlined = _resolveComponent("InteractionOutlined");
  const _component_FileTextOutlined = _resolveComponent("FileTextOutlined");
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined");
  const _component_a_menu = _resolveComponent("a-menu");
  const _component_AimOutlined = _resolveComponent("AimOutlined");
  const _component_AlignLeftOutlined = _resolveComponent("AlignLeftOutlined");
  const _component_a_layout_sider = _resolveComponent("a-layout-sider");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  const _component_MessageOutlined = _resolveComponent("MessageOutlined");
  const _component_a_badge = _resolveComponent("a-badge");
  const _component_UserOutlined = _resolveComponent("UserOutlined");
  const _component_a_avatar = _resolveComponent("a-avatar");
  const _component_DownOutlined = _resolveComponent("DownOutlined");
  const _component_a_dropdown = _resolveComponent("a-dropdown");
  const _component_a_layout_header = _resolveComponent("a-layout-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_a_layout_content = _resolveComponent("a-layout-content");
  const _component_a_layout_footer = _resolveComponent("a-layout-footer");
  const _component_a_layout = _resolveComponent("a-layout");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_layout, {
    id: "components-layout-demo-custom-trigger",
    class: "frame"
  }, {
    default: _withCtx(() => [_createVNode(_component_a_layout_sider, {
      collapsed: $data.collapsed,
      "onUpdate:collapsed": _cache[9] || (_cache[9] = $event => $data.collapsed = $event),
      trigger: null,
      collapsible: "",
      class: "sideMenu"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = (...args) => $options.goIntegratedPlatform && $options.goIntegratedPlatform(...args))
      }), $data.isPM || $data.isAdmin ? (_openBlock(), _createBlock(_component_a_menu, {
        key: 0,
        theme: "dark",
        mode: "inline",
        selectedKeys: $data.selectedKeys,
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = $event => $data.selectedKeys = $event),
        openKeys: $data.openKeys,
        "onUpdate:openKeys": _cache[2] || (_cache[2] = $event => $data.openKeys = $event),
        onClick: $options.onClickMenu
      }, {
        default: _withCtx(() => [$data.isPM || $data.isAdmin ? (_openBlock(), _createBlock(_component_a_menu_item, {
          key: "100"
        }, {
          default: _withCtx(() => [_createVNode(_component_HomeOutlined), _createElementVNode("span", null, _toDisplayString($data.privateDeploy ? _ctx.$t("home_page") : _ctx.$t("home_page2")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_sub_menu, {
          key: "sub1"
        }, {
          title: _withCtx(() => [_createVNode(_component_ProjectOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("project_management")), 1)]),
          default: _withCtx(() => [$data.isPM || $data.isAdmin ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "101"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("new_project")), 1)]),
            _: 1
          })) : _createCommentVNode("", true), $data.isPM || $data.isAdmin ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "102"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("project_released")), 1)]),
            _: 1
          })) : _createCommentVNode("", true), $data.isPM || $data.isAdmin ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "103"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("project_going")), 1)]),
            _: 1
          })) : _createCommentVNode("", true), $data.isPM || $data.isAdmin ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "104"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("project_finish")), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), $data.isPM || $data.isAdmin ? (_openBlock(), _createBlock(_component_a_sub_menu, {
          key: "sub3"
        }, {
          title: _withCtx(() => [_createVNode(_component_ToolOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("config_management")), 1)]),
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            key: "15"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("tool_config")), 1)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            key: "10"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("improt_export_rules")), 1)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            key: "4"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("error_management")), 1)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            key: "7"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("invalid_image")), 1)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            key: "13"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("rules_config")), 1)]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), ($data.isPM || $data.isAdmin) && $data.privateDeploy ? (_openBlock(), _createBlock(_component_a_sub_menu, {
          key: "sub2"
        }, {
          title: _withCtx(() => [_createVNode(_component_UsergroupAddOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("personnel_management")), 1)]),
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            key: "201"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("taggers_manager")), 1)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            key: "202"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("acceptor_management")), 1)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            key: "203"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("team_management")), 1)]),
            _: 1
          }), $data.isAdmin ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "204"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("pm")), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), ($data.isPM || $data.isAdmin) && !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_sub_menu, {
          key: "sub4"
        }, {
          title: _withCtx(() => [_createVNode(_component_GlobalOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("algorithm_management")), 1)]),
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            key: "401"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("algorithm_list")), 1)]),
            _: 1
          }), $data.isAdmin ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "402"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("algorithm_call")), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), $data.isAdmin && !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_menu_item, {
          key: "51"
        }, {
          default: _withCtx(() => [_createVNode(_component_SoundOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("announcement_management")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), ($data.isPM || $data.isAdmin) && !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_menu_item, {
          key: "5"
        }, {
          default: _withCtx(() => [_createVNode(_component_InteractionOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("management_log")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $data.isAdmin && !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_menu_item, {
          key: "6"
        }, {
          default: _withCtx(() => [_createVNode(_component_FileTextOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("documentManagement")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $data.docmentList.length > 0 && !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_sub_menu, {
          key: "sub8"
        }, {
          title: _withCtx(() => [_createVNode(_component_QuestionCircleOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("questionCircleOutlined")), 1)]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.docmentList, (item, index) => {
            return _openBlock(), _createBlock(_component_a_menu_item, {
              key: `${item.url}-${item.id}`
            }, {
              default: _withCtx(() => [_createElementVNode("a", {
                onClick: e => $options.toDocment(e, item)
              }, _toDisplayString(item.name), 9, _hoisted_2)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["selectedKeys", "openKeys", "onClick"])) : _createCommentVNode("", true), $data.isTagger ? (_openBlock(), _createBlock(_component_a_menu, {
        key: 1,
        theme: "dark",
        mode: "inline",
        selectedKeys: $data.selectedKeys,
        "onUpdate:selectedKeys": _cache[3] || (_cache[3] = $event => $data.selectedKeys = $event),
        openKeys: $data.openKeys,
        "onUpdate:openKeys": _cache[4] || (_cache[4] = $event => $data.openKeys = $event),
        onClick: $options.onClickMenu
      }, {
        default: _withCtx(() => [_createVNode(_component_a_menu_item, {
          key: "1001"
        }, {
          default: _withCtx(() => [_createVNode(_component_HomeOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("home_page2")), 1)]),
          _: 1
        }), _createVNode(_component_a_menu_item, {
          key: "1003"
        }, {
          default: _withCtx(() => [_createVNode(_component_AimOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("project_management")), 1)]),
          _: 1
        }), $data.docmentList.length > 0 && !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_sub_menu, {
          key: "sub8"
        }, {
          title: _withCtx(() => [_createVNode(_component_QuestionCircleOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("questionCircleOutlined")), 1)]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.docmentList, (item, index) => {
            return _openBlock(), _createBlock(_component_a_menu_item, {
              key: `${item.url}-${item.id}`
            }, {
              default: _withCtx(() => [_createElementVNode("a", {
                onClick: e => $options.toDocment(e, item)
              }, _toDisplayString(item.name), 9, _hoisted_3)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["selectedKeys", "openKeys", "onClick"])) : _createCommentVNode("", true), $data.isSupplier ? (_openBlock(), _createBlock(_component_a_menu, {
        key: 2,
        theme: "dark",
        mode: "inline",
        selectedKeys: $data.selectedKeys,
        "onUpdate:selectedKeys": _cache[5] || (_cache[5] = $event => $data.selectedKeys = $event),
        openKeys: $data.openKeys,
        "onUpdate:openKeys": _cache[6] || (_cache[6] = $event => $data.openKeys = $event),
        onClick: $options.onClickMenu
      }, {
        default: _withCtx(() => [_createVNode(_component_a_menu_item, {
          key: "2001"
        }, {
          default: _withCtx(() => [_createVNode(_component_ProjectOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("project_management")), 1)]),
          _: 1
        }), $data.privateDeploy ? (_openBlock(), _createBlock(_component_a_menu_item, {
          key: "2003"
        }, {
          default: _withCtx(() => [_createVNode(_component_AlignLeftOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("personnel_management")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $data.docmentList.length > 0 && !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_sub_menu, {
          key: "sub8"
        }, {
          title: _withCtx(() => [_createVNode(_component_QuestionCircleOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("questionCircleOutlined")), 1)]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.docmentList, (item, index) => {
            return _openBlock(), _createBlock(_component_a_menu_item, {
              key: `${item.url}-${item.id}`
            }, {
              default: _withCtx(() => [_createElementVNode("a", {
                onClick: e => $options.toDocment(e, item)
              }, _toDisplayString(item.name), 9, _hoisted_4)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["selectedKeys", "openKeys", "onClick"])) : _createCommentVNode("", true), $data.isCustom ? (_openBlock(), _createBlock(_component_a_menu, {
        key: 3,
        theme: "dark",
        mode: "inline",
        selectedKeys: $data.selectedKeys,
        "onUpdate:selectedKeys": _cache[7] || (_cache[7] = $event => $data.selectedKeys = $event),
        openKeys: $data.openKeys,
        "onUpdate:openKeys": _cache[8] || (_cache[8] = $event => $data.openKeys = $event),
        onClick: $options.onClickMenu
      }, {
        default: _withCtx(() => [_createVNode(_component_a_menu_item, {
          key: "3001"
        }, {
          default: _withCtx(() => [_createVNode(_component_ProjectOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("projectOutlined")), 1)]),
          _: 1
        }), $data.docmentList.length > 0 && !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_sub_menu, {
          key: "sub8"
        }, {
          title: _withCtx(() => [_createVNode(_component_QuestionCircleOutlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t("questionCircleOutlined")), 1)]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.docmentList, (item, index) => {
            return _openBlock(), _createBlock(_component_a_menu_item, {
              key: `${item.url}-${item.id}`
            }, {
              default: _withCtx(() => [_createElementVNode("a", {
                onClick: e => $options.toDocment(e, item)
              }, _toDisplayString(item.name), 9, _hoisted_5)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["selectedKeys", "openKeys", "onClick"])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["collapsed"]), _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [_createVNode(_component_a_layout_header, {
        style: {
          "background": "#fff",
          "padding": "0"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_a_select, {
          value: $data.language,
          "onUpdate:value": _cache[10] || (_cache[10] = $event => $data.language = $event),
          style: {
            "width": "100px"
          },
          onChange: $options.onLanguageChange
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select_option, {
            value: "zhCN"
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("中文")])),
            _: 1
          }), _createVNode(_component_a_select_option, {
            value: "enUS"
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("English")])),
            _: 1
          })]),
          _: 1
        }, 8, ["value", "onChange"])]), !$data.isTagger ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[11] || (_cache[11] = (...args) => $options.gotoMessage && $options.gotoMessage(...args))
        }, [_createVNode(_component_a_badge, {
          count: $data.msgCount,
          class: "cursor-pointer mr-3"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_MessageOutlined)])]),
          _: 1
        }, 8, ["count"])])) : _createCommentVNode("", true), $data.isTagger ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[12] || (_cache[12] = (...args) => $options.gotoTagMessage && $options.gotoTagMessage(...args))
        }, [_createVNode(_component_a_badge, {
          count: $data.msgCount,
          class: "cursor-pointer ml-3 mr-4"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_MessageOutlined)])]),
          _: 1
        }, 8, ["count"])])) : _createCommentVNode("", true), _createVNode(_component_a_dropdown, {
          class: "pre-step",
          offset: 1
        }, {
          overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
            default: _withCtx(() => [!$data.isTagger && !$data.isSupplier && !$data.isCustom ? (_openBlock(), _createBlock(_component_a_menu_item, {
              key: "ding",
              onClick: $options.showDingDing,
              class: "text-center"
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("bind_dingtalk_account")), 1)]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_menu_item, {
              key: "exit",
              onClick: $options.exitLogin,
              class: "text-center"
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("exit")), 1)]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("a", {
            class: "ant-dropdown-link",
            onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"]))
          }, [_createVNode(_component_a_avatar, {
            size: "small"
          }, {
            icon: _withCtx(() => [_createVNode(_component_UserOutlined)]),
            _: 1
          }), _createElementVNode("span", _hoisted_10, _toDisplayString($data.person.name), 1), !$data.isTagger && !$data.isSupplier && !$data.isCustom ? (_openBlock(), _createBlock(_component_DownOutlined, {
            key: 0
          })) : _createCommentVNode("", true)])]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_a_layout_content, {
        class: "layout-content"
      }, {
        default: _withCtx(() => [$data.isRouterAlive ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0
        }, {
          default: _withCtx(({
            Component
          }) => [_createVNode(_Transition, {
            name: "fade-transform",
            mode: "out-in"
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
            _: 2
          }, 1024)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), $data.showFooter ? (_openBlock(), _createBlock(_component_a_layout_footer, {
        key: 0,
        class: "layout-footer"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("footer_text")), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_a_modal, {
    title: _ctx.$t('bind_dingtalk_account'),
    visible: $data.visible,
    "onUpdate:visible": _cache[15] || (_cache[15] = $event => $data.visible = $event),
    onOk: $options.handleOk
  }, {
    default: _withCtx(() => [_createVNode(_component_a_form, null, {
      default: _withCtx(() => [_createVNode(_component_a_form_item, {
        label: _ctx.$t('dingtalk_account'),
        "wrapper-col": {
          span: 18,
          offset: 1
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: $data.ddAccount,
          "onUpdate:value": _cache[14] || (_cache[14] = $event => $data.ddAccount = $event),
          placeholder: _ctx.$t('ph_dingtalk_account')
        }, null, 8, ["value", "placeholder"])]),
        _: 1
      }, 8, ["label"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["title", "visible", "onOk"])]);
}